interface OrderLike {
  testTypes?: {
    id?: number;
    name?: string;
    limsTestName?: string;
    DecisionDxPRAMEDescription?: string;
  };
  secondaryTestType?: {
    name?: string;
    limsTestName?: string;
  };
  testTypeId?: string;
  isReportPrame?: boolean;
}

/**
 * Builds the test display label for an order (subheader, side nav, order info).
 * When testTypeId is 4 and isReportPrame is true, includes DecisionDx-PRAME (short form or full description from DecisionDxPRAMEDescription).
 */
function getOrderTestDisplayLabel(
  order: OrderLike | null | undefined,
  options?: { useFullName?: boolean; useFullPrameDescription?: boolean }
): string {
  if (!order?.testTypes) return "";

  const useFullName = options?.useFullName === true;
  const useFullPrameDescription = options?.useFullPrameDescription === true;
  const primary = useFullName
    ? (order.testTypes.name ?? order.testTypes.limsTestName ?? "")
    : (order.testTypes.limsTestName ?? order.testTypes.name ?? "");
  const secondary = order.secondaryTestType
    ? useFullName
      ? (order.secondaryTestType.name ?? order.secondaryTestType.limsTestName ?? "")
      : (order.secondaryTestType.limsTestName ?? order.secondaryTestType.name ?? "")
    : "";

  const isType4 =
    order.testTypes.id === 4 ||
    order.testTypeId === "4";
  const isType4WithPrame = isType4 && !!order?.isReportPrame;
  const prameDesc = order.testTypes.DecisionDxPRAMEDescription;

  if (isType4WithPrame) {
    const prameDisplay =
      useFullPrameDescription && prameDesc != null && prameDesc !== ""
        ? prameDesc
        : prameDesc != null && prameDesc !== ""
          ? (prameDesc.split(":")[0]?.trim() || "DecisionDx-PRAME")
          : "DecisionDx-PRAME";
    const secondaryPart = secondary !== "" ? ` / ${secondary}` : "";
    return `${primary}${secondaryPart} / ${prameDisplay}`;
  }

  if (secondary !== "") {
    return `${primary} / ${secondary}`;
  }

  return primary;
}

export default getOrderTestDisplayLabel;
